import React, {Component} from 'react';
import {Select, Typography,Form,DatePicker,InputNumber, Input, Button, Spin, message} from 'antd';

import {appStore} from '../../stores/AppStore';
import {getTitleEmailUrl, updateTitleActorInfo, getWorkflow, projectTitle, getTaskwithoutworkflow} from "../../stores/APIEndpoints";
import {anyNull, validateEmail} from "../../stores/Util";

const {Text} = Typography;
const {Option} = Select;

export class ChangeTitleEmails extends Component {
   

    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            titleId: undefined,
            role: undefined,
            emails: undefined,
            names: undefined,
            loading: false,
            titleList:'',
            selectTasks:'',
            selectWorkflow:'',
            projectTitles:[]
        };
       
    }
    async componentDidMount() {
       this.populatetitle();
        // this.getTitle();
        // this.getTaskList();
        // this.getWorkflowList();
    }
    getTitle = async () => {
        let response = await this.apiProxy.getAsync(projectTitle);
        const option = await response.json();
        this.setState({titleList:option});
    };
    getTaskList = async() =>{
        const bodyParams = { "select": ["id", "name" ], "where": []};
          let response = await this.apiProxy.asyncPost(getTaskwithoutworkflow, bodyParams);
          const option = await response.json();
          this.setState({selectTasks:option});
    }
    getWorkflowList = async () => {
        const bodyParams = { "select": ["id", "name" ], "where": []};
        let response = await this.apiProxy.asyncPost(getWorkflow, bodyParams);
        const option = await response.json();
        this.setState({selectWorkflow:option});
     //   this.getTaskList();
      };
    populatetitle = async () => {
        let response = await this.apiProxy.getAsync(projectTitle);
        const option = await response.json();
        // this.setState({"projectTitles":option});
        this.setFiltereditOptions(0, option.map(t => ({
          name: t.shortTitle,
          label: t.shortTitle,
          value: t.id
        })));
      }
      setFiltereditOptions = (index, options) => {
        this.setState({"projectTitles":options});
      };

    render() {
        const {selectTasks, titleList, selectWorkflow, projectTitles} = this.state;
        const titles=[];
        for(let i=0; i<projectTitles.length;i++)
        {
           
            titles.push(<Option value={projectTitles[i].value}>{projectTitles[i].name}</Option>)
        }

        const { getFieldDecorator } = this.props.form;
            const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },

            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 },
            },
            
            };
            const config = {
                rules: [{ type: 'object', required: true, message: 'Please select time!' }],
              };
       
       
        return (
            // <Form {...formItemLayout} style={{marginTop:"30px"}}>
            //     <Form.Item label="Title"  name="titleId">
            //         {getFieldDecorator('titleId', {
            //             rules: [{required: true}]
            //         })(
            //             <Select showSearch  placeholder="Select a title" optionFilterProp="children">
            //                  {titleList != "" ? titleList.map(value =>  <Option value={value.id}>{value.shortTitle}</Option>) : <Option value=''>''</Option>}
            //             </Select>
            //         )}
            //     </Form.Item>
            //     <Form.Item label="Leaf Type"  name="leafType">
            //         {getFieldDecorator('leafType', {
            //             rules: []
            //         })(
            //             <Select showSearch placeholder="Select a leaf type" optionFilterProp="children">
            //             <Option value={'Print/Online'}>Print/Online</Option>
            //             <Option value={'Online'}>Online</Option>
            //             </Select>
            //         )}
            //     </Form.Item>
            //     <Form.Item label="Vendor"  name="vendor">
            //         {getFieldDecorator('vendor', {
            //             rules: []
            //         })(
            //         <Select defaultValue="PubKit" placeholder="Select a vendor">
            //             <Option value="PubKit">PubKit</Option>
            //             <Option value="LAPS">LAPS</Option>
            //         </Select>
            //         )}
            //     </Form.Item>
            //     <Form.Item label="CM Names"  name="Cm" >
            //         {getFieldDecorator('future_cm', {
            //             rules: []
            //             })(
            //             <Input style={{ width: '100%' }}  placeholder="Enter the CM names" />
            //             )}
            //         </Form.Item>
                    
            //             <Form.Item label="CM Emails"  name="CmEmails" >
            //             {getFieldDecorator('future_cmEmails', {
            //                 rules: []
            //                 })(
            //                 <Input style={{ width: '100%' }} placeholder="Enter the CM emails" />
            //                 )}
            //             </Form.Item>
            //         <Form.Item label="Editor Names"  name="Editor" >
            //         {getFieldDecorator('future_editor', {
            //             rules: []
            //             })(
            //             <Input style={{ width: '100%' }}  placeholder="Enter the edidor names"  />
            //             )}
            //         </Form.Item>
            //         <Form.Item label="Editor Emails"  name="EditorEmails" >
            //             {getFieldDecorator('future_editorEmails', {
            //                 rules: []
            //                 })(
            //                 <Input style={{ width: '100%' }}  placeholder="Enter the edidor emails" />
            //                 )}
            //         </Form.Item>
            //     <Form.Item label="Workflow"  name="Workflow">
            //         {getFieldDecorator('globalWorkflowId', {
            //             rules: []
            //         })(
            //             <Select showSearch  placeholder="Select a workflow" optionFilterProp="children">
            //              {selectWorkflow != "" ? selectWorkflow.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
            //             </Select>
            //         )}
            //     </Form.Item>
            //     <Form.Item label="Pickup for next edition for Authors"  name="msAbstractTaskId">
            //     {getFieldDecorator('msAbstractTaskId', {
            //         rules: []
            //         })(
            //         <Select showSearch placeholder="select pickup for next edition for authors" optionFilterProp="children">
            //              {selectTasks != "" ? selectTasks.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
            //         </Select>
            //         )}
            //       </Form.Item>
            //       <Form.Item label="Reseed Type"  name="ReseedType">
            //         {getFieldDecorator('reseedType', {
            //         rules: []
            //             })(
            //             <Select showSearch defaultValue="BASEDONATASK"  placeholder="Select a reseed type" optionFilterProp="children" onChange={this.onChangeReseedType}>
            //                 <Option value={"BASEDONATASK"}>BASED ON A TASK</Option>
            //                 <Option value={"FIXED"}>FIXED</Option>
            //                 <Option value={"BASEDONTHELASTUPDATEDATE"}>BASED ON THE LAST UPDATE DATE</Option>
            //             </Select>
            //             )}
            //         </Form.Item>
            //         <Form.Item label="Recycle Period"  name="RecyclePeriod" >
            //         {getFieldDecorator('recyclePeriod', {
            //             rules: []
            //             })(
            //             <InputNumber style={{ width: '100%' }} placeholder="Enter the recycle period" onChange={this.onchangeRecyclePeriod}/>
            //             )}
            //         </Form.Item>
            //         <Form.Item>
            //              <Button style={{"float":"right","margin-top":"10px"}} type="primary"  htmlType="submit" className="login-form-button">Submit </Button>
            //         </Form.Item>
            // </Form>
            <div style={styles.root}>

                <Spin spinning={this.state.loading}>
                    <div style={styles.section}>
                        <div style={styles.selectItem}>
                            <Text>Select Title</Text>
                            <Select value={this.state.titleId} onChange={this.handleTitleChange} placeholder={'Title'}>
                              {titles}
                            </Select>
                        </div>

                        <div style={styles.selectItem}>
                            <Text>Select Actor</Text>
                            <Select value={this.state.role} onChange={this.handleActorChange} placeholder={'Actor'}>
                                <Option value="editor">Editor</Option>
                                <Option value="cm">CM</Option>
                            </Select>
                        </div>
                    </div>

                    <div style={styles.section}>
                        <div style={styles.selectItem}>
                            <Text>Names</Text>
                            <Input placeholder="Names" value={this.state.names} onChange={this.handleNameChange}/>
                        </div>

                        <div style={styles.selectItem}>
                            <Text>Emails</Text>
                            <Input placeholder="Email Address" value={this.state.emails}
                                   onChange={this.handleEmailChange}/>
                        </div>
                    </div>

                    <div style={{...styles.section, flexDirection: 'column'}}>
                        <Button type="primary" style={{alignSelf: 'flex-end'}} onClick={this.handleSubmit}>
                            Update
                        </Button>
                    </div>
                </Spin>
            </div>
        );
    }

    handleTitleChange = (value) => {
        this.setState({titleId: value});
        this.getActorInfoFor(value, this.state.role);
    };

    handleActorChange = (value) => {
        this.setState({role: value});
        this.getActorInfoFor(this.state.titleId, value);
    };

    handleEmailChange = (e) => {
        this.setState({emails: e.target.value});
    };

    handleNameChange = (e) => {
        this.setState({names: e.target.value});
    };

    validateInputs = () => {
        const {titleId, names, emails, role} = this.state;
        if (anyNull(titleId, names, emails, role)) {
            message.warn('Please enter all information');
            return false;
        }
        const emailList = emails.split(';');
        const nameList = names.split(';');
        const validSize = emailList.length === nameList.length;

        if (!validSize) {
            message.warn('Please enter same number of name and email with ; separated values');
            return false;
        }
        let validEmails = emailList.reduce((valid, e) => validateEmail(e.trim()) && valid, true);

        if (!validEmails) {
            message.warn('Please enter valid email addresses');
            return false;
        }

        return true;
    };

    getActorInfoFor = async (titleId, role) => {
        if (!titleId || !role) {
            return;
        }

        this.setState({loading: true});
        try {
            const params = {titleId, role};
            const response = await this.apiProxy.asyncPost(getTitleEmailUrl, params);
            let data = await response.json();
            this.setState({emails: data.emails, names: data.names});
        } catch (e) {
        }
        this.setState({loading: false});
    };

    handleSubmit = async () => {
        const valid = this.validateInputs();
        if (!valid) return;
        this.setState({loading: true});

        try {
            // const {loading, ...params} = this.state;
            const bodyParams = {"role":this.state.role,"emails":this.state.emails,"names":this.state.names,"titleId":this.state.titleId}
            const response = await this.apiProxy.asyncPost(updateTitleActorInfo, bodyParams);
            message.success('Updated successfully');
        } catch (e) {
            message.error('Unable to update details');
        }
        this.setState({loading: false});
    }
}

const styles = {
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    selectItem: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: '0px 10px',
    },
    section: {
        display: 'flex',
        flex: 1,
        fledDirection: 'row',
        padding: '10px 0px'
    }
};
export default Form.create({ name: 'normal_login' })(ChangeTitleEmails);